// Copyright 2016 Sorama B.V.

import { IValueConverter } from "aurelia-binding-ext";

export class StringEmptyToBooleanValueConverter implements IValueConverter<boolean, string> {
    public toView(value: string): boolean {
        return !value;
    }

    public fromView(value: boolean): string {
        return "";
    }
}
